module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/piper-db1149c9d5e77d8d5b35ae549970a6c5.png";